import React, { } from "react";
export default function HomeFooter() {
    const year = new Date().getFullYear();
    return (
        <div className="home-footer">
            <div className="outer-container">
                <div className="home-footer-overlay"></div>
            <p className="footer-para">Copyright © {year} xilligence</p>
            </div>
        </div>
    );
}
